/**
 * @generated SignedSource<<3d2b5768c248347d2db1a04259d97a5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserEventsPastSection_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventList_query">;
  readonly " $fragmentType": "UserEventsPastSection_query";
};
export type UserEventsPastSection_query$key = {
  readonly " $data"?: UserEventsPastSection_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserEventsPastSection_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserEventsPastSection_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventList_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ff94837bf6346d684fce860edf312a46";

export default node;
